<template>
  <div class="qr">
    <QrGeneratorThree/>
  </div>
</template>

<script>
// @ is an alias to /src
import QrGeneratorThree from "../../components/QrGeneratorThree";
export default {
  name: 'scantwo',
  components:{
    QrGeneratorThree
  }
}
</script>
<style>
  .qr{
    /*background-color: #4281ff;*/
    /*height:540px;*/
    /*background-image: linear-gradient(90deg, #733AEA 0%, #217CF6 100%);*/
    /*border: 1px solid #979797;*/
    /*color:white;*/
  }
</style>
